<template>
  <div class="toast-container">
    <TransitionGroup
      name="toast-list"
      tag="div"
      class="toast-container__list"
    >
      <ToastItem
        v-for="toast in toasts"
        :key="toast.id"
        :variant="toast.variant"
        :title="toast.title"
        :message="toast.message"
        :actions="toast.actions"
        :duration="toast.timeout"
        :dark="dark"
        @close="$toast.remove(toast.id)"
        @action="(action) => onAction(toast, action)"
      />
    </TransitionGroup>
  </div>
</template>

<script>
import ToastItem from './ToastItem.vue';
import { toastApi } from '@/plugins/toast';

export default {
  name: 'ToastContainer',
  components: { ToastItem },
  props: {
    dark: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      toasts: []
    };
  },
  mounted() {
    this.updateToasts();
    toastApi.eventBus.$on('toasts-changed', this.updateToasts);
  },
  beforeDestroy() {
    toastApi.eventBus.$off('toasts-changed', this.updateToasts);
  },
  methods: {
    updateToasts() {
      this.toasts = toastApi.getToasts();
    },
    onAction(toast, action) {
      if (typeof action.handler === 'function') {
        action.handler();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.toast-container {
  position: fixed;
  top: 24px;
  right: 24px;
  z-index: 9999;
  pointer-events: none;
}

.toast-container__list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  pointer-events: auto;
}

.toast-list-enter-active,
.toast-list-leave-active {
  transition: all 0.3s ease;
}

.toast-list-enter-from {
  opacity: 0;
  transform: translateY(-24px);
}

.toast-list-leave-to {
  opacity: 0;
  transform: translateY(-24px);
}

.toast-list-move {
  transition: transform 0.3s ease;
}
</style>
